const navbarList = document.querySelectorAll('.ja_bs_navbar');

function initHamburgerMenuBtn(navbar, collapseEl) {
  collapseEl.addEventListener('show.bs.collapse', function () {
    navbar.querySelector('.navbar-toggler .hamburger').classList.add('is-active');
    navbar.querySelector('.navbar-brand__shadow').classList.add('is-opened');

    const gtmEvent = {
      trigger: 'click on navigation',
      event_id: '1.12',
      event: 'menu_open',
      event_campaign: 'general',
      content_type: 'navigation button',
      category: 'navigation',
      market: window.getMarketFromUrl()
    };
    window.dataLayer.push(gtmEvent);

  });
  collapseEl.addEventListener('hide.bs.collapse', function () {
    navbar.querySelector('.navbar-toggler .hamburger').classList.remove('is-active');
    navbar.querySelector('.navbar-brand__shadow').classList.remove('is-opened');
  });
}

function initNavigationLinks(navbar) {
  const navLinks = navbar.querySelectorAll('.js_navbar-nav a');

  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const linkUrl = this.href;
      const linkText = this.textContent.trim();

      const gtmEvent = {
        trigger: 'click on navigation link',
        event_id: '1.13',
        event: 'menu_content',
        link_url: linkUrl,
        event_campaign: 'general',
        content_type: 'navigation link',
        content_id: linkText,
        category: 'navigation',
        market: window.getMarketFromUrl()
      };

      window.dataLayer.push(gtmEvent);
    });
  });
}

if (navbarList.length) {
  for (let i = 0; i < navbarList.length; i++) {
    const navbar = navbarList[i];
    const collapseEl = navbar.querySelector('.collapse');

    const bsCollapse = new bootstrap.Collapse(collapseEl, {
      toggle: false
    });

    initHamburgerMenuBtn(navbar, collapseEl);
    initNavigationLinks(navbar);

    const logoLink = navbar.querySelector('.navbar-brand__link');
    if (logoLink) {
      logoLink.addEventListener('click', function (e) {

        const gtmEvent = {
          trigger: 'click on logo',
          event_id: '1.6',
          event: 'select_content',
          link_url: logoLink.href,
          event_campaign: 'general',
          content_type: 'logo header',
          category: 'navigation',
          market: window.getMarketFromUrl()
        };
        window.dataLayer.push(gtmEvent);
        console.log('Logo Clicked: ', gtmEvent);
      });
    }

  }
}
